module.exports = __webpack_public_path__ + "media/images/collapse-882efc46fec9a3a047cdee01427c1583.svg";